import { AccountAPI } from 'api/build/accountAPI';

export * from 'api/build/accountAPI';
// eslint-disable-next-line
export default new AccountAPI();
